import { useState, useEffect } from 'react';
import { get, post } from 'aws-amplify/api';
import { CompanyProfile, AdminProfileSetupProps } from '../../types';
import { CompanyManager } from './CompanyManager';

export function AdminProfileSetup({
  onProfileCreated,
}: AdminProfileSetupProps) {
  const [companies, setCompanies] = useState<CompanyProfile[]>([]);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState('');
  const [message, setMessage] = useState('');
  const [refreshKey, setRefreshKey] = useState(0);

  const fetchCompanies = async () => {
    try {
      const restOperation = get({
        apiName: 'aslanwebsftpapi',
        path: '/companies',
      });
      const { body } = await restOperation.response;
      const companyList = (await body.json()) as unknown as CompanyProfile[];
      setCompanies(companyList);
      if (companyList.length > 0 && !selectedCompanyId) {
        setSelectedCompanyId(companyList[0].id);
      }
    } catch (error) {
      console.error('Error fetching companies:', error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, [refreshKey]);

  const handleCreateAdminProfile = async (
    e: React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();
    setMessage('Creating your profile...');
    try {
      await post({
        apiName: 'aslanwebsftpapi',
        path: '/profiles',
        options: {
          body: { firstName, lastName, companyId: selectedCompanyId },
        },
      }).response;
      setMessage('Profile created successfully! Refreshing...');
      onProfileCreated();
    } catch (error) {
      console.error('Error creating admin profile:', error);
      setMessage('Failed to create profile. Check console for details.');
    }
  };

  return (
    <div>
      <p>
        Welcome, Admin. To get started, create a company and then create a user
        profile for yourself using your own email address. This will grant you
        full access.
      </p>
      <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap' }}>
        <div style={{ flex: 1.5, minWidth: '400px' }}>
          <CompanyManager
            onCompaniesUpdate={() => setRefreshKey((k) => k + 1)}
          />
        </div>
        <div
          style={{
            border: '1px solid #ccc',
            padding: '15px',
            marginTop: '20px',
            flex: 1,
            minWidth: '300px',
          }}
        >
          <h3>Create Your Admin Profile</h3>
          <form onSubmit={handleCreateAdminProfile}>
            <div>
              <label>
                First Name:{' '}
                <input
                  type='text'
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  required
                />
              </label>
            </div>
            <div>
              <label>
                Last Name:{' '}
                <input
                  type='text'
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  required
                />
              </label>
            </div>
            <div>
              <label>
                Company:
                <select
                  value={selectedCompanyId}
                  onChange={(e) => setSelectedCompanyId(e.target.value)}
                  required
                >
                  <option value='' disabled>
                    Select a company
                  </option>
                  {companies.map((c: CompanyProfile) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            <button type='submit' disabled={!selectedCompanyId}>
              Create My Profile
            </button>
          </form>
          {message && <p>{message}</p>}
        </div>
      </div>
    </div>
  );
}
